module.exports = __webpack_public_path__ + "static/media/aswathy.a940bd2d.jpeg";